import React from 'react';

export default function ActionCard({ label, onClick, color = '#0d6efd' }) {
  return (
    <button
      className="quick-action-btn"
      style={{ '--qa-color': color }}
      onClick={onClick}
      type="button"
    >
      {label}
    </button>
  );
}
